import { addDays, setHours, setMinutes, subDays } from "date-fns";
import { useState } from "react";
import { useAppointmentsStore } from "~/features/dashboard/pages/calendar/store";
import { CalendarEvent } from "../../components";
import { MedicationRefills } from "./components/medication-refills";
import { useSuspenseQuery } from "@tanstack/react-query";
import { calendarRefillsQueryOptions } from "../../api/queries";
import { useParams } from "@tanstack/react-router";
import { getApiProgram } from "~/lib/utils";
// import { EventCalendar, type CalendarEvent } from "../components";

const sampleEvents: CalendarEvent[] = [
  {
    id: "1",
    type: "refill",
    title: "Amoxicillin Refill",
    description: "Monthly prescription refill",
    start: subDays(new Date(), 24),
    end: subDays(new Date(), 23),
    allDay: true,
    color: "sky",
    prescriptionId: "RX123456",
    clientName: "Maurice Umoh",
    medication: "Amoxicillin",
    quantity: 30,
    request_datetime: "2025-05-01T17:19:28",
    status: "pending"
  },
  {
    id: "2",
    type: "refill",
    title: "Metformin Refill",
    description: "Diabetes medication refill",
    start: setMinutes(setHours(subDays(new Date(), 9), 13), 0),
    end: setMinutes(setHours(subDays(new Date(), 9), 15), 30),
    color: "amber",
    prescriptionId: "RX789012",
    clientName: "Sandra Obi",
    medication: "Metformin",
    quantity: 60,
    request_datetime: "2025-05-01T17:19:28",
    status: "accepted"
  },
  {
    id: "3",
    type: "refill",
    title: "Lisinopril Refill",
    description: "Blood pressure medication",
    start: subDays(new Date(), 13),
    end: subDays(new Date(), 13),
    allDay: true,
    color: "orange",
    prescriptionId: "RX345678",
    clientName: "Miriam Ekong",
    medication: "Lisinopril",
    quantity: 90,
    request_datetime: "2025-05-01T17:19:28",
    status: "rejected"
  },
  {
    id: "4",
    type: "refill",
    title: "Atorvastatin Refill",
    description: "Cholesterol medication",
    start: setMinutes(setHours(new Date(), 10), 0),
    end: setMinutes(setHours(new Date(), 11), 0),
    color: "sky",
    prescriptionId: "RX901234",
    clientName: "Chizzy Nwosu",
    medication: "Atorvastatin",
    quantity: 30,
    request_datetime: "2025-05-01T17:19:28",
    status: "pending"
  },
  {
    id: "5",
    type: "refill",
    title: "Insulin Refill",
    description: "Diabetes medication",
    start: setMinutes(setHours(addDays(new Date(), 1), 12), 0),
    end: setMinutes(setHours(addDays(new Date(), 1), 13), 15),
    color: "emerald",
    prescriptionId: "RX567890",
    clientName: "Kobi Ikenna",
    medication: "Insulin",
    quantity: 5,
    request_datetime: "2025-05-01T17:19:28",
    status: "accepted"
  }
]

export function RefillPage() {
  const {program} = useParams({strict: false})
  const [events, setEvents] = useState<CalendarEvent[]>(sampleEvents)
  const refillsQuery = useSuspenseQuery(calendarRefillsQueryOptions({program: getApiProgram(program ?? "")}));
  const { view, setView } = useAppointmentsStore();


  const handleEventAdd = (event: CalendarEvent) => {
    setEvents([...events, event])
  }

  const handleEventUpdate = (updatedEvent: CalendarEvent) => {
    setEvents(events.map((event) => (event.id === updatedEvent.id ? updatedEvent : event)))
  }

  const handleEventDelete = (eventId: string) => {
    setEvents(events.filter((event) => event.id !== eventId))
  }

  // const timeRange = {
  //   start: sampleEvents.map(s => s.start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })).toString() ,
  //   end: sampleEvents.map(e => e.start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })).toString()
  // };

  // console.log(timeRange.start + " - " + timeRange.end);
  

  return (
    <MedicationRefills
      events={refillsQuery.data}
      view={view}
      // timeRange={}
      setView={setView}
      onEventAdd={handleEventAdd}
      onEventUpdate={handleEventUpdate}
      onEventDelete={handleEventDelete}
    />
  )

}
